import './styles.scss'
import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import Header from '../../../components/Header/Header'
import LandingLocale from 'components/common/LandingLocale'

const Landing = () => {

  return (
    <div className='app landing'>
      <Header />

      <div className='full-percent-height'>
        <main>
          <Container className='animated fadeIn landing' fluid>
            <div className='landing-header'>
              <Row className='my-5 px-sm-5'>
                <Col xs={12} sm={8} lg={6}>
                  <h1 className='page-title'>{I18n.t('dashboard_landing-title')}</h1>
                </Col>
              </Row>
            </div>
            <div className='landing-content'>
              <Row className='justify-content-center'>
                <Col xs={12} sm={8} lg={5}>
                  <h2
                    className='section-title'
                    dangerouslySetInnerHTML={{ __html: I18n.t('dashboard_landing-subtitle') }}
                  />
                </Col>
              </Row>
            </div>
          </Container>
        </main>

        <LandingLocale
          direction='top'
        />
      </div>
    </div>
  )
}

export default Landing
